export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/nh2UTRcerGyVH5x1byQ1xD/PAGINA_6.png',
    alt: 'Sample page From Quarry to Silo Is One Continuous Process: the cement plant at a glance, from quarry and crusher to cement silos and dispatch',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nv24ft4dP4PmJe56icC4eB/PAGINA_11.png',
    alt: 'Sample page The Raw Mill Turns Rock into Flour: vertical roller mill versus ball mill cutaways with a comparison table',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5RP83yUvDfSbtSYnhxsSdG/PAGINA_16.png',
    alt: 'Sample page The Preheater Is a Tower of Heat Exchangers: cyclone preheater stage by stage with a technical warning and takeaway',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tJbcVu83kg1hK7ugnGEepD/PAGINA_18.png',
    alt: 'Sample page The Kiln Is a Rotating Furnace with Zones: rotary kiln cutaway with temperature profile and the four kiln zones',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/viCY9NNQksVUJyCharMeEB/PAGINA_22.png',
    alt: 'Sample page The Flame Shapes the Clinker: main burner, flame shapes and conventional fuels with a technical warning',
  },
];
